module.exports = __webpack_public_path__ + "3becbab416ce9bf4.svg";